
import EmailAuth from "@/components/EmailAuth.vue"
import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common';

@Component({
  components: {
    EmailAuth
  }
})

export default class SignUpEmail extends Mixins(Common) {

  async created(){
    console.trace('created');
  }
 
 async mounted(){
  console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }
}
